<template>
  <div class="row">
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            @exibirPretos="handleExibirPretos"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            :disabledBlack="disabledBlack"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="select-situacao info-table-item">
          <vue-select
            :options="filterMeses"
            label="label"
            placeholder="Meses"
            v-model="filter"
            @input="
              filter !== null
                ? filtros(
                    exibirCadastrosVermelhos,
                    exibirCadastrosVerdes,
                    exibirCadastrosPretos,
                    $event
                  )
                : filtros(
                    exibirCadastrosVermelhos,
                    exibirCadastrosVerdes,
                    exibirCadastrosPretos,
                    {
                      situacao: 'Todos',
                    }
                  )
            "
            :clearable="true"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="dose-imunizante"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :vacinasRegistradas="vacinasRegistradas"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'DoseImunizante',
  metaInfo: {
    title: 'Dose imunizante',
    titleTemplate: null,
  },
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      vacinasRegistradas: [],
      cadastrosOriginais: [],
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      exibirCadastrosPretos: false,
      disabledRed: false,
      disabledGreen: false,
      disabledBlack: false,
      filterMeses: [
        { label: '4 meses', value: '4 meses' },
        { label: '5 meses', value: '5 meses' },
        { label: '6 meses', value: '6 meses' },
        { label: '9 meses', value: '9 meses' },
        { label: '12 meses', value: '12 meses' },
        { label: '15 meses', value: '15 meses' },
      ],
      filter: '',
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde, preto, filter) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = Functions.exibirTodos(this.cadastrosOriginais)
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
      this.exibirCadastrosPretos = false
      // Se null setar como vazio
      if (filter === null) {
        this.filter = ''
        filter = ''
      }
      if (filter !== '') {
        data = Functions.handleFilter(data, filter.value)
      }
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVerdes = true
      }

      if (preto === true) {
        data = Functions.exibirPretos(data)
        this.exibirCadastrosPretos = true
      }

      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false, false, this.filter)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosPretos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true, false, this.filter)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
          this.exibirCadastrosPretos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    handleExibirPretos(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          this.filtros(false, false, true, this.filter)
          this.exibirCadastrosPretos = true
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    async buscarVacinas() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (user) {
          this.nomeProfissional = user.data.nome
          //pega a equipe do acs
          let equipe = await this.$api.get(
            '/app/equipe/' + this.cod_ibge + '/' + user.data.nu_ine
          )
          if (equipe) {
            this.nomeEquipe = equipe.data.no_equipe
          }
          let response = await this.$api.post(
            '/app/dose-imunizante/profissional',
            {
              co_ibge: this.cod_ibge,
              cpf: user.data.cpf,
            }
          )
          this.cadastrosOriginais = response.data
          this.cadastros = response.data
          this.total_de_registros_da_tabela = response.data.length
          this.filtros(true, false, false, this.filter)
          this.setRed = true
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, '', this.nomeProfissional)
    },

    async init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      await this.buscarVacinas()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
